import { StringUnit, ListUnit, DictUnit } from '@activejs/core';
import { STEPS } from '../lib/constants';

// https://dev.to/dabalyan/state-management-with-a-single-line-of-code-2llg
export const stepUnit = new StringUnit({
  id: 'stepUnit',
  immutable: true,
  persistent: false,
  cacheSize: 10,
  initialValue: STEPS.waiting,
});

export const selectedOfferIdUnit = new StringUnit({
  id: 'selectedOfferIdUnit',
  immutable: true,
  persistent: false,
  cacheSize: 10,
  initialValue: '',
});

export const userInfoUnit = new DictUnit({
  id: 'userInfoUnit',
  immutable: true,
  persistent: false,
  cacheSize: 10,
  initialValue: {},
});

export const offersUnit = new ListUnit({
  id: 'offersUnit',
  immutable: true,
  persistent: false,
  cacheSize: 10,
  initialValue: [],
});
